import React from "react";
import { Phone } from "lucide-react";
import { BRAND } from "../lib/content";

export default function FloatingCallButton() {
  return (
    <a
      href={BRAND.phoneHref}
      data-testid="floating-call-btn"
      className="md:hidden fixed bottom-5 right-5 z-40 inline-flex items-center gap-2 px-5 py-3.5 bg-[#C9A86A] text-black uppercase tracking-[0.18em] text-[11px] shadow-2xl shadow-black/40"
    >
      <Phone className="w-4 h-4" />
      Call now
    </a>
  );
}
